const astralia = {
  id: 2,
  code: '61',
  country: 'Australia',
};

export const countries = [astralia];

export const phoneCountryCodes = ['Australia'];
